import { Button } from "primereact/button";
import { classNames } from "primereact/utils";

import styles from "../../filter-panel.module.scss";
import type { FilterPanelFooterViewProps } from "./types-footer";

export function FilterPanelFooterView({
  className,
  hidden,
  isMobile,
  rest,
  startItems,
  saveItems,
  clearButton,
  applyButton,
}: FilterPanelFooterViewProps) {
  return (
    <footer
      className={classNames(styles.footer, isMobile && styles.footerMobile, className)}
      {...rest}
      hidden={hidden}
    >
      <div className={styles.footerStart}>{startItems}</div>
      <div className={styles.footerEnd}>
        {clearButton ? (
          <Button
            type="button"
            className={clearButton.className}
            icon={clearButton.icon}
            label={clearButton.label}
            text
            severity="secondary"
            disabled={clearButton.disabled}
            onClick={clearButton.onClick}
            data-testid={clearButton.testId}
          />
        ) : null}
        {saveItems}
        <Button
          type="button"
          className={applyButton.className}
          label={applyButton.label}
          disabled={applyButton.disabled}
          onClick={applyButton.onClick}
          data-testid={applyButton.testId}
        />
      </div>
    </footer>
  );
}
